// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ssufp","approved":"Status_approved__14MER","rejected":"Status_rejected__2DE4V","expired":"Status_expired__T_YhW","label":"Status_label__2b5S9"};